import { apiWithBody } from '@nu-art/thunderstorm-frontend';
import { Module } from '@nu-art/ts-common';
import { ApiDef_EHREmulator } from '@app/ehr-emulator-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend';
import { PermissionKeys_EHREmulatorUI } from '@app/ehr-emulator-shared';
export class ModuleFE_EHREmulator_Class extends Module {
    _v1;
    permissions;
    constructor() {
        super();
        this._v1 = {
            getEventsWithSimulations: apiWithBody(ApiDef_EHREmulator._v1.getEventsWithSimulations),
            getEventsWithSimulationsByEncounterId: apiWithBody(ApiDef_EHREmulator._v1.getEventsWithSimulationsByEncounterId),
            getBucketsForEvent: apiWithBody(ApiDef_EHREmulator._v1.getBucketsForEvent),
            getEventsWithSimulationsByFilters: apiWithBody(ApiDef_EHREmulator._v1.getEventsWithSimulationsByFilters),
            downloadBugReportFile: apiWithBody(ApiDef_EHREmulator._v1.downloadBugReportFile),
        };
        this.permissions = PermissionKey_FE.generatePermissionKeysByLevels(PermissionKeys_EHREmulatorUI);
    }
}
export const ModuleFE_EHREmulator = new ModuleFE_EHREmulator_Class();
//# sourceMappingURL=ModuleFE_EHREmulator.js.map